// extracted by mini-css-extract-plugin
export default {"gap_20":"UserAgeGroup_gap_20__1Z2cs"};